import React, { useState } from "react";
import i18n from 'utils/i18n'
import HomeBookSelectCoworkerIndexTabFavourites from './_tabs/favourites'
import HomeBookSelectCoworkerIndexTabCoWorkers from './_tabs/coworkers'
import HomeBookSelectCoworkerIndexTabExternal from './_tabs/external'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import ThemedLayout from 'components/atoms/ThemedLayout'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation, useRoute } from "@react-navigation/native";
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import _ from "lodash";
import HelperString from 'utils/helper-string'
import TabbedContent from 'components/molecules/TabbedContent'
import { TESTID } from '_shared/config/testID'
import EmployeeFooter from 'scenes/home/book/_components/EmployeeFooter'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'
import Translate from 'utils/translate'
import { timeslotGroupForTitle } from 'scenes/home/book/coworker/_functions/TimeslotGroupFunctions'
import { constantsActive } from 'utils/constants/constants'
import selectFavourites from 'services/redux/data/selectors/selectFavourites'
import selectTimeslotGroup from 'services/redux/data/selectors/selectTimeslotGroup'
import useRouteParameters from 'utils/hooks/use-route-parameters'


const HomeBookSelectCoworkerIndexScene = () => {
	const navigation = useNavigation();
	const route = useRoute();
	const _routeParameters = useRouteParameters( route );
	
	const [ topTabbar, setTopTabbar ] = useState( null )
	const [ footerHeight, setFooterHeight ] = useState( 0 )
	
	const _favourites = useSelector( selectFavourites );
	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} ); // hook to settings even though they're not directly used (but it refreshes the page when options changed)
	
	const _timeslotGroup = useSelector( state => {
		return selectTimeslotGroup(state, _.get(_routeParameters, routeBookingConstants.TIMESLOT_GROUP));
	} ); // do not remove, required for reloading
	const _bookForOption = _.get( _routeParameters, routeBookingConstants.FOR_OPTION );
	
	if( _timeslotGroup === undefined ) {
		return null;
	}
	
	const tabBarItems = [];
	if( _timeslotGroup.can_book_for_coworkers === constantsActive.YES ) {
		if( _.size( _favourites ) > 0 ) {
			tabBarItems.push({
				key: 'favourites',
				text: i18n.t( 'page.create.coworker.mode_favourites'),
				scene: ( props ) => {
					return <HomeBookSelectCoworkerIndexTabFavourites />;
				},
				testID: TESTID.HOME.BOOK.COWORKER.NAVIGATION.FAVOURITES
			})
		}
	
		tabBarItems.push({
			key: 'co_workers',
			text: i18n.t( 'page.create.coworker.mode_co_workers'),
			scene: ( props ) => {
				return <HomeBookSelectCoworkerIndexTabCoWorkers />;
			},
			testID: TESTID.HOME.BOOK.COWORKER.NAVIGATION.COWORKERS
		});
	}
	
	if( _timeslotGroup.can_book_for_external === constantsActive.YES ) {
		tabBarItems.push({
			key: 'search',
			text: i18n.t( 'page.create.coworker.mode_external'),
			scene: ( props ) => {
				return <HomeBookSelectCoworkerIndexTabExternal />;
			},
			testID: TESTID.HOME.BOOK.COWORKER.NAVIGATION.EXTERNAL
		});
	}
	
	const save = () => {
		navigation.navigate( AppRoutes.ADD_BOOKING_VIEW_COWORKER,
			_routeParameters
		);
	}
	
	const title = Translate.field( _timeslotGroup, 'title' );
	const subtitle = timeslotGroupForTitle( _bookForOption, _timeslotGroup );

	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				contentWidth="narrow"
				title={ title }
				subtitle={ subtitle }
				showBackButton={ true }
				topNavigation={ true }
				topTabbar={ topTabbar }
				footerBar={ footerHeight > 0 }
				enableScrollView={ false }
				style={ {
					paddingBottom: footerHeight + 10
				} }>
				
				<TabbedContent
					key={ HelperString.hash('profile-tabs' ) }
					topTabbar={ setTopTabbar }
					items={ tabBarItems }
				/>
			</ThemedLayout>
			
			<EmployeeFooter
				onHeight={ setFooterHeight }
				onPressSubmit={ save }
				submitLabel={ i18n.t( 'page.create.coworker.check_coworkers' ) }
			/>
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeBookSelectCoworkerIndexScene;
